module.exports = __webpack_public_path__ + "static/img/griffin.d40f215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/brands/griffin.jpg
// module id = Kf9t
// module chunks = 1